import React, { useContext } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import AuthContext from 'providers/Auth/Auth.context';
import { Button } from 'ncoded-component-library';
import FleetManagerLogo from 'assets/images/Fleet-manager-logo.png';

import './FmHeader.styles.scss';
import './FmHeader.styles.responsive.scss';

type FmHeaderProps = {
  className?: string;
};

const FmHeader: React.FC<FmHeaderProps> = (props) => {
  const { className } = props;
  const { t } = useTranslation();
  const { logoutRequest } = useContext(AuthContext);

  const classes = classNames('fm-header', className);

  return (
    <header className={classes}>
      <img className="fm-logo-img" src={FleetManagerLogo} alt="fm-logo-img" />

      <div className="fm-header__right-menu">
        <Button variant="link" onClick={() => logoutRequest()}>
          {t('logOut')}
        </Button>
      </div>
    </header>
  );
};

export default FmHeader;
